module.exports = __webpack_public_path__ + "c98ef7d5cd55d9ccbf0381123da94b68.svg";